import { Button, Col, Form, FormInstance, Modal, Row, Space } from "antd";
import OtpInput from "../../../otp/Index";
import { ReactComponent as MailSend } from '../../../../assets/images/mail_send.svg';
import { useLazyGenerateOtpQuery, useValidateOtpMutation } from "../../../forgot-password/redux/ForgotPasswordApi";
import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../../redux/Hooks";
import { LoadingOutlined } from "@ant-design/icons";
import FloatInput from "../../../common/components/FloatInput";
import ConfirmModal from "../../../common/components/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { OTPActions } from "../../../common/types/types";

interface Props {
    visible: boolean;
    toggleVisible: () => void;
    form: FormInstance<any>;
}

const OtpInsertModal = ({ visible, toggleVisible, form }: Props) => {
    const userState = useAppSelector(state => state.login);
    const [sendOtp, { isLoading, isSuccess }] = useLazyGenerateOtpQuery();
    const [validateOtp, { isLoading: isLoadingValidateOtp }] = useValidateOtpMutation();
    const [currentEmail, setCurrentEmail] = useState("");
    const [inputs, setInputs] = useState<string[]>(Array(8).fill(""));
    const [displayEmailForm, setDisplayEmailForm] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);
    const [error, setError] = useState("");
    const otpSentFirstTime = useRef(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!currentEmail && userState.user.email && !otpSentFirstTime.current) {
            sendOtp({email: userState.user.email, action: OTPActions.CHANGE_MAIL}).unwrap().then(res => {
                setCurrentEmail(userState.user.email!);
            }).catch(err => {
                setError(err.data?.message || "Đã có lỗi xảy ra.")
            })
        }
    }, [currentEmail, sendOtp, userState.user.email])

    useEffect(() => {
        if (isSuccess) {
            otpSentFirstTime.current = true;
        }
    }, [isSuccess])

    const onConfirmClick = () => {
        if (currentEmail === userState.user.email) {
            validateOtp({ email: currentEmail, otp: inputs.join("") }).unwrap().then(() => {
                setDisplayEmailForm(true);
                setError("");
                setCurrentEmail("");
                setInputs(Array(8).fill(""));
            }).catch(err => {
                setError(err.data?.message || "Đã có lỗi xảy ra.")
            })
        } else {
            validateOtp({ email: currentEmail, otp: inputs.join("") }).unwrap().then(() => {
                if (form) {
                    setError("");
                    setSuccessVisible(true);
                    if (userState.user?.roleCodes?.includes("ORGANIZATION")) {
                        form.setFieldsValue({ organizationMail: currentEmail })
                    } else {
                        form.setFieldsValue({ email: currentEmail });
                    }
                    form.submit();
                }
            }).catch(err => {
                setError(err.data?.message || "Đã có lỗi xảy ra.")
            })
        }
    }

    const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentEmail(e.target.value);
    }

    const emailChangeClick = () => {
        if (currentEmail === userState.user.email) {
            setError("Email mới không được trùng email cũ.")
        } else {
            setDisplayEmailForm(false);
            sendOtp({email: currentEmail, action: OTPActions.CONFIRM_CHANGE_MAIL}).unwrap().then(() => {
                setError("");
            }).catch(err => {
                setError(err.data?.message || "Đã có lỗi xảy ra.")
            })
        }
    }

    const onBackButtonClick = () => {
        // Nếu không nhận được mã OTP sau khi nhập email mới
        // Ấn nút back sẽ quay lại màn nhập email mới
        if (currentEmail !== userState.user.email && isSuccess) {
            setDisplayEmailForm(true);
        } else {
            toggleVisible();
        }
    }

    return (
        <Modal
            visible={visible}
            footer={false}
            className="custom-modal"
            onCancel={toggleVisible}
        >
            <div style={{ display: 'flex', alignItems: "center", justifyContent: 'center', flexDirection: 'column' }}>
                <MailSend />
                {(isLoading || isLoadingValidateOtp) ?
                    <Row align="middle" justify="center">
                        <Col span={24} style={{ marginTop: 16, marginBottom: 10, fontSize: 18 }}>
                            {isLoading ? "Đang gửi OTP" : "Đang xác nhận OTP"}
                        </Col>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <LoadingOutlined style={{ marginTop: 15, fontSize: 18 }} />
                        </Col>
                    </Row>
                    : <></>}

                {!isLoading && !isLoadingValidateOtp ?
                    <>
                        {displayEmailForm ?
                            <Row align="middle" justify="center">
                                <Col span={24} style={{ marginTop: 16, fontSize: 18, textAlign: 'center' }}>
                                    Đổi Email
                                </Col>
                                <Col span={24} style={{ textAlign: 'center', marginTop: 10, marginBottom: 10, color: 'red' }}>
                                    {error || ""}
                                </Col>
                                <Form initialValues={{ email: "" }} onFinish={emailChangeClick}>
                                    <Col span={24}>
                                        <Form.Item
                                            name="email"
                                            rules={[{ type: 'email', message: 'Email không đúng định dạng' },
                                            { required: true, message: "Email mới là bắt buộc." }]}>
                                            <FloatInput placeholder="Nhập email mới" label="Nhập email mới" onChange={onEmailChange} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'center', marginTop: 20 }}>
                                        <Space>
                                            <Button className="button-gray" onClick={toggleVisible} style={{ width: 160, height: 50 }}>Trở về</Button>
                                            <Button className="button-light-yellow" htmlType="submit" style={{ width: 160, height: 50 }}>
                                                Gửi mã xác nhận
                                            </Button>
                                        </Space>
                                    </Col>
                                </Form>
                            </Row> :
                            <Row align="middle" justify="center">
                                <Col span={24} style={{ marginTop: 16, fontSize: 18, textAlign: 'center' }}>
                                    {currentEmail === userState.user.email ? "Nhập mã gửi đến email hiện tại." : "Nhập mã gửi đến email mới."}
                                </Col>
                                <Col span={24} style={{ textAlign: 'center', marginTop: 10, marginBottom: 10, color: 'red' }}>
                                    {error || ""}
                                </Col>
                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <OtpInput inputs={inputs} setInputs={setInputs} key={currentEmail} />
                                </Col>
                                <Col span={24} style={{ textAlign: 'center', marginTop: 20 }}>
                                    <Space>
                                        <Button className="button-gray" onClick={onBackButtonClick} style={{ width: 160, height: 50 }}>Trở về</Button>
                                        <Button
                                            className="button-light-yellow"
                                            onClick={onConfirmClick}
                                            style={{ width: 160, height: 50 }}
                                            loading={isLoading || isLoadingValidateOtp}>
                                            {currentEmail === userState.user.email ? "Đổi Email" : "Xác nhận"}
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>}
                    </> : <></>}
            </div>

            {successVisible ?
                <ConfirmModal
                    noCancelButton
                    visible={successVisible}
                    onCancel={() => navigate(0)}
                    onOk={() => { navigate(0) }}
                    status="success"
                    okText="Đóng"
                    title={<>
                        <div style={{ color: "#97BC2D" }}>Đổi Email thành công</div>
                    </>}
                />
                : <></>}
        </Modal >
    )
}

export default OtpInsertModal;